import { affiliates } from "../images-index";

function About (){
    console.log("About.js rerenders");

    let listAffilliates = affiliates.map(temp =><a href = {temp.site_link}><img key = {temp.key} src={temp.link} /></a> );

 return(
    <div className="fans-list-container">
        {/* HEADER */}
        <div className="header-bar">What is a fanlisting?</div>
        <div className="info">
            <p>A fanlisting is simply an online list of fans of a subject, such as a TV show, actor, or musician, that is created by an individual and open for fans from around the world to join.</p>
            <p>TLDR: This is a place where fans of Slay the Princess can find each other's sites!</p> 
            </div>
        <div className="header-bar-about">How do I join?</div>
        <div className="info">
            <p>To join the fanlisting, submit the form <a href="/join">here</a> with your details. You should be added in a week or two.</p>
        </div>
        <div className="header-bar-about">Credits</div>
        <div className="info">
            <p>All assets used by this site are from <a href="https://www.slaytheprincess.com/">Slay the Princess</a> and belong to <a href="https://blacktabbygames.com/">Black Tabby Games</a>, unless otherwise stated.</p>

        </div>

        <div className="header-bar-about">Affiliates</div>
        <div className="buttons-display">
            {listAffilliates}
        </div>
        <div className="info">
            <p>If you'd like to become an affiliate, email <a href="mailto:marketchipping@proton.me">Aranea</a> with the details! I would love to link to related fanlistings, or fanlistings for other indie games.</p>
        </div>

        <div className="header-bar-about">Other</div>
        <div className="info">
            <p>This site went live on July 9th, 2026.</p>
        </div>
        
        </div>
       )
}
export default About;